import { z } from "zod";
import { ComponentRoleSchema } from "./component-role.js";
import { ContentEntityTypeSchema, SurfaceTypeSchema } from "./surface-grammar.js";
import { CertificationLifecycleStatusSchema } from "./strategy.js";
export const CertifiedComponentStatusSchema = z.enum([
    "DRAFT",
    "CERTIFICATION_REVIEW",
    "ACTIVE",
    "ACTIVE_WITH_WARNINGS",
    "DEPRECATED",
    "BLOCKED_FOR_NEW_PROJECTS",
    "RETIRED",
]);
export const ComponentDataRequirementSchema = z
    .object({
    path: z.string().min(1),
    description: z.string().min(1),
})
    .strict();
export const CertifiedComponentDefinitionSchema = z
    .object({
    componentId: z.string().min(1),
    componentVersion: z.string().min(1),
    role: ComponentRoleSchema,
    displayName: z.string().min(1),
    status: CertifiedComponentStatusSchema,
    surfacePackId: z.string().min(1),
    lifecycleStatus: CertificationLifecycleStatusSchema.default("candidate"),
    supportedSurfaceTypes: z.array(SurfaceTypeSchema).default(["marketingSite"]),
    supportedEntityTypes: z.array(ContentEntityTypeSchema).default(["localServiceBusiness"]),
    supportedStrategies: z.array(z.string().min(1)).default([]),
    supportedLensIds: z.array(z.string().min(1)).default([]),
    requiredData: z.array(ComponentDataRequirementSchema).default([]),
    optionalData: z.array(ComponentDataRequirementSchema).default([]),
    forbiddenWhen: z.array(z.string().min(1)).default([]),
    fallbackBehavior: z.string().min(1).optional(),
    emptyStateBehavior: z.string().min(1).optional(),
    mobileFixture: z.string().min(1).optional(),
    accessibilityRequirements: z.array(z.string().min(1)).default([]),
    clientSafeEditPermissions: z.array(z.string().min(1)).default([]),
    agencyEditPermissions: z.array(z.string().min(1)).default([]),
    qaChecks: z.array(z.string().min(1)).default([]),
    variants: z
        .array(z
        .object({
        variantId: z.string().min(1),
        responsiveFixtureId: z.string().min(1),
    })
        .strict())
        .optional(),
    clientSafe: z.boolean(),
    qualityTags: z.array(z.string().min(1)).default([]),
    renderAdapterKey: z.string().min(1),
})
    .strict();
export const CertifiedComponentRegistryV1Schema = z
    .object({
    schemaVersion: z.literal("certified-component-registry.v1.0"),
    registryVersion: z.string().min(1),
    components: z.array(CertifiedComponentDefinitionSchema),
})
    .strict()
    .superRefine((registry, ctx) => {
    const seen = new Set();
    for (const component of registry.components) {
        const key = `${component.componentId}@${component.componentVersion}`;
        if (seen.has(key)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `duplicate component definition: ${key}`,
                path: ["components"],
            });
        }
        seen.add(key);
    }
});
//# sourceMappingURL=certified-component.js.map